<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <!--      sidebar setting start-->
      <sidebar></sidebar>
      <!--      sidebar setting end-->
      <div class="setting-info-wrp">
        <!-- general-setting -->
        <div class="general-setting">
          <div class="box">
            <div class="sett-head">
              <h1>General settings</h1>
              <p>Here you can edit your CleverStaff settings. Select a setting to edit it. Please make sure to notify
                your employees of relevant changes.</p>
            </div>
            <ul class="settings">
              <li>
                <strong class="sett-title">Name of account</strong>
                <p><a href="javascript:void(0)" class="text-capitalize">{{ company.name }}</a></p>
              </li>
              <li>
                <strong class="sett-title">CleverStaff domain</strong>
                <p><a href="javascript:void(0)">{{ hostname }} </a></p>
              </li>
              <li>
                <strong class="sett-title">Post code</strong>
                <p><a href="javascript:void(0)">{{ company.postcode }}</a></p>
              </li>

            </ul>
          </div>
          <div class="box">
            <div class="sett-head">
              <h1>Notifications</h1>
            </div>
            <ul class="settings">
              <li>
                <strong class="sett-title">Auto notification send to employees before 5 minutes starting shift and after 5 minutes shift ended</strong>
                <p>
                  <input type="checkbox" @change="updateCompanyLeaveSetting" :true-value="1" :false-value="0"
                         v-model="allow_notification_before_shift">
                </p>
              </li>
            </ul>

            <div class="sett-head">
              <h1>Language and Time Settings</h1>
            </div>
            <ul class="settings">
              <li>
                <strong class="sett-title">Choose your country</strong>
                <p><a href="javascript:void(0)" class="text-capitalize">{{ company.country }}</a></p>
              </li>
              <!--              <li>
                              <strong class="sett-title">Timezone</strong>
                              <p><a href="javascript:void(0)">{{ timezone }}</a></p>
                            </li>-->
              <li>
                <strong class="sett-title">Language</strong>
                <p><a href="javascript:void(0)">English(US)</a></p>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../../router/router'
import axios from "axios";
import DatePicker from "vue2-datepicker";
import sidebar from "./sidebar";

export default {
  components: {
    DatePicker,
    sidebar,
  },
  props: [],
  data() {
    return {
      company_id: this.$store.getters.getSelectedCompany.id,
      companyData: {},
      company: this.$store.getters.getSelectedCompany,
      timezone: this.$store.getters.getUser.accessToken.timezone,
      hostname: '',
      allow_notification_before_shift: 0,
    }
  },
  serverPrefetch() {
  },
  created() {
    this.getDomain()
    this.getCompany()
  },
  mounted() {

  },
  methods: {
    updateCompanyLeaveSetting(){
      axios.post(this.$UpdateCompanyLeaveSetting,
        {
          allow_notification_before_shift: this.allow_notification_before_shift,
          company_id: this.company_id,
        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status == 200) {
            $root.$toast.success("Updated successfully");
          }
        });
    },
    getDomain() {
      this.hostname = location.host;
    },
    getCompany() {
      axios.get(this.$showcompanies + '/' + this.company_id + '/edit', {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.companyData = res.data.result.company;
            this.allow_notification_before_shift=this.companyData.allow_notification_before_shift;
          }
        });
    },
  }
}
</script>
